module.exports = __webpack_public_path__ + "static/media/background_grid.4d7d941d.gif";